import { DataGrid } from '@mui/x-data-grid';
import { ClearAll, Search } from '@mui/icons-material';
import { UploadFile, Upload } from '@mui/icons-material';
import { Alert, Box, IconButton, Snackbar, TablePagination, TextField, Button, Checkbox, FormControlLabel, FormGroup, MenuItem, Select} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import DeviceUpload from '../pages/DeviceUpload';
import ApiServices from '../services/ApiServices';
import Popup from './Popup';
import SelectionForm from './SelectionForm';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeviceLog from '../pages/DeviceLog';
import OTAErrorModal from './utility/OTAErrorModal';

function DeviceTable(props) {

    const columns = [
        {
            field: 'checkbox', flex: 0.4, sortable: false,
            renderHeader: () => {
                const calledClick = (e) => {
                    const allImeiNoOta = devices.map(i => i.deviceIMEI);
                    if (e.target.checked) setPutUnderOTA((oldList) => [...oldList, ...allImeiNoOta])
                    else setPutUnderOTA((item) => item.filter((item) => !allImeiNoOta.includes(item)));
                }
                const selectedAll = () => {
                    if (devices.length > 0) return devices.every(item => putunderOTA.includes(item.deviceIMEI));
                    else return false;
                }
                return <Checkbox style={{ padding: 9 }} checked={selectedAll()} onClick={calledClick} />;
            },
            renderCell: (params) => {
                const stopExtra = (e) => {
                    if (e.target.checked) setPutUnderOTA(oldLIst => [...oldLIst, params.id])
                    else setPutUnderOTA((item) => item.filter((item) => item !== params.id));
                }
                const isSelected = () => { return putunderOTA.includes(params.id); }
                return <Checkbox checked={isSelected()} onClick={stopExtra} />;
            }
        },
        {
            field: 'organisationName', headerName: 'Organisation', flex: 1.5, sortable: false,
            renderCell: (params) => renderValue(params.row.organisationName)
        },
        {
            field: 'groupName', headerName: 'Group', flex: 1.5, sortable: false,
            renderCell: (params) => renderValue(params.row.groupName)
        },
        { field: 'deviceIMEI', headerName: 'IMEI', flex: 0.9, sortable: false, },
        {
            field: 'serialNumber', headerName: 'Serial number', flex: 0.8, sortable: false,
            renderCell: (params) => renderValue(params.row.serialNumber)
        },
        {
            field: 'bootloaderVersion', headerName: 'Bootloader', flex: 0.6, sortable: false,
            renderCell: (params) => {
                if (params.row.bootloaderVersion) return params.row.bootloaderVersion;
                else return "N/A"
            }
        },
        { field: 'flashMagicVersion', headerName: 'Flash magic', flex: 0.6, sortable: false, },
        {
            field: 'appVersion', headerName: 'App version', flex: 0.6, sortable: false,
            renderCell: (params) => renderValue(params.row.appVersion)
        },
        {
            field: 'mcuType', headerName: 'MCU Type', flex: 0.8, sortable: false,
            renderCell: (params) => renderValue(params.row.mcuType)
        },
        {
            field: 'counterOta', headerName: 'Counter', flex: 0.8, sortable: false,
            renderCell: (params) => renderValue(params.row.counterOta)
        },
        {
            field: 'action', headerName: 'Action', flex: 0.5, sortable: false,
            renderCell: (params) => {
                const viewLog = (e) =>{
                    e.stopPropagation();
                    setDeviceIMEIForLog(params.id);
                    setOpenLogPopup(true);                    
                }
                return <>                   
                    <IconButton color="success" title="View Log" onClick={viewLog}>
                        <SyncAltIcon />
                    </IconButton>
                </>;
            }
        }
    ];

    const renderValue = (value) => {
        return <div style={{ lineHeight: "1.2", overflowWrap: "break-word", whiteSpace: "normal", overflow: "auto", maxHeight: "inherit" }}>{value}</div>
    }
    const [devices, setDevices] = React.useState([]);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [openDeviceUploadPopup, setOpenDeviceUploadPopup] = React.useState(false);

    // to set log tables for single device.
    const [deviceIMEIForLog, setDeviceIMEIForLog] = React.useState();
    const [openLogPopup, setOpenLogPopup] = React.useState(false);
    
    // search params
    const imeiRef = useRef('');
    const organisationRef = useRef('');
    const groupRef = useRef('');
    const bootloaderVerRef = useRef('');
    const appVerRef = useRef('');
    const mcuTypeRef = useRef('');
    const [deviceType, setDeviceType] = React.useState('All');

    // pop up 
    const [alertObj, setAlertObj] = React.useState({ open: false, severity: "success", message: "" });
    const [otaErrors, setOtaErrors] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);

    // select devices
    const [putunderOTA, setPutUnderOTA] = React.useState([]);



    const performOTA = () => {
        if (putunderOTA.length > 0) {
            setOpenPopup(true)
        } else {
            setAlertObj({ open: true, severity: "error", message: "Select the device first." })
        }
    }
    // Paginatation 
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalRow, setTotalRow] = React.useState(-1);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const search = () => {
        getDeviceDetails();
    }
    const getDevicesData = () => {
        setPage(0);
        getDeviceDetails();
        if(bootloaderVerRef.current?.value?.trim() ||
        imeiRef.current?.value?.trim() ||
        appVerRef.current?.value?.trim() ||
        mcuTypeRef.current?.value?.trim() ||
        organisationRef.current?.value?.trim() ||
        groupRef.current?.value?.trim()){                                              
            setEnableSelectAll(true);
        }else{            
            setEnableSelectAll(false);
        }
    }

    const getDeviceDetails = () => {
        ApiServices.searchDevices(getSearchParamas(),imeiRef.current.value.trim())
            .then(response => {
                if (response.status === 200) {
                    setDevices(response.data);
                    setTotalRow(Number(response.headers['x-total']))
                } else {
                    setDevices([]);
                }
            })
            .catch(error => {
                console.error(error);
                setAlertObj({ open: true, severity: "error", message: error.message });
                setDevices([]);
            }).finally(()=>{
                setSelectAll(()=> false);
                setPutUnderOTA(()=>[]);
            });
    }
    const getSearchParamas = () => {
        var searchParams = new URLSearchParams();
        if (bootloaderVerRef.current.value.trim()) searchParams.append("bootloader", bootloaderVerRef.current.value.trim());
        if (appVerRef.current.value.trim()) searchParams.append("appVersion", appVerRef.current.value.trim());
        if (mcuTypeRef.current.value.trim()) searchParams.append("mcutype", mcuTypeRef.current.value.trim());
        if (organisationRef.current.value.trim()) searchParams.append("orgName", organisationRef.current.value.trim());
        if (groupRef.current.value.trim()) searchParams.append("groupName", groupRef.current.value.trim());
        if (deviceType !== 'All') searchParams.append("deviceType", deviceType);
        searchParams.append("page", page);
        searchParams.append("size", rowsPerPage);
        searchParams.append("sort", "createdAt,desc");
        return searchParams.toString();
    }

    const handleDeviceTypeChange = (event) => {
        setDeviceType(event.target.value || '');
    };

    const handleOTASubmit = (reqObject) => {
        ApiServices.addDeviceToOTA(reqObject)
            .then(response => {
                if(response.status === 200){                    
                    setAlertObj({
                        open: true,
                        severity: "success",
                        message: response.data.length > 0 ? response.data : "Successfully added to OTA list."
                    });
                } else if (response.status === 206) {                    
                    const parsedErrors = parseErrors(response.data);
                    setOtaErrors(parsedErrors);
                    setShowErrorModal(true);
                }
                setPutUnderOTA(() => []);
                setOpenPopup(false);
                search();
            })
            .catch(error => {
                console.error(error.response?.data);
                setIsErrorTrue(error.response?.data || "Something went wrong");
                setTimeout(() => {
                    setIsErrorTrue("");
                }, 5000);
            });
    };

    const parseErrors = (errors) => {
        return {
            notFound: errors.filter(msg => msg.includes("not found")),
            configIssues: errors.filter(msg =>
                msg.includes("version is missing") || msg.includes("MCU Type is missing")
            ),
            fileMissing: errors.filter(msg => msg.includes("file missing")),
            otherErrors: errors.filter(msg => msg.includes("Unexpected error"))
        };
    };

    // on error show msg
    const [isErrorTrue, setIsErrorTrue] = React.useState("");

    const handleDeviceUploadSubmit = (status, messages) => {
        setOpenDeviceUploadPopup(false);
        setAlertObj({ open: true, severity: status, message: messages })
        search();
    }


    const clearSelectedDevice = () => {
        if (putunderOTA.length > 0) {
            setPutUnderOTA(() => []);
            setAlertObj({ open: true, severity: "success", message: "Cleared all selected devices." })
        }
    }

    const handleClose = () => {
        setAlertObj({ open: false, severity: alertObj.severity });
    };

    const uploadDevcies = () => {
        setOpenDeviceUploadPopup(true);
    }
    // Select All
    const [enableSelectAll,setEnableSelectAll] = useState(false);    
    
    const [selectAll, setSelectAll] = React.useState(false);
    const selectAllDevices = (e) => {               
        if(e.target.checked){
            setSelectAll(() => true);
            ApiServices.getDevicesIMEIs(getSearchParamas(),imeiRef.current.value.trim())
            .then(response => {
                if (response.status === 200) {                    
                    setPutUnderOTA(() => response.data);                    
                }
            })
            .catch(error => {
                console.error(error);
                setAlertObj({ open: true, severity: "error", message: error.message });
            })
        }else{
            clearSelectedDevice();
            setSelectAll(()=> false);
        }        
    }

    useEffect(() => {
        search();
    }, [page, rowsPerPage])


    return (
        <div style={{ height: 600, width: '100%' }}>
            <Box sx={{
                width: "100%"
            }}>
                <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1 },
                        width: "80%"
                    }}
                    noValidate
                    autoComplete="off"
                    display="inline-block"
                >
                    <TextField id="organisation" size="small" sx={{ width: 150 }} label="Organisation" variant="outlined" inputRef={organisationRef} />
                    <TextField id="group" size="small" sx={{ width: 150 }} label="Group" variant="outlined" inputRef={groupRef} />
                    <TextField id="imei" size="small" sx={{ width: 170 }} label="IMEI" variant="outlined" inputRef={imeiRef} />
                    <TextField id="bootloader" size="small" sx={{ width: 150 }} label="Bootloader" variant="outlined" inputRef={bootloaderVerRef} />
                    <TextField id="appVersion" size="small" sx={{ width: 150 }} label="App version" variant="outlined" inputRef={appVerRef} />
                    <TextField id="mcutype" size="small" sx={{ width: 150 }} label="MCU type" variant="outlined" inputRef={mcuTypeRef} />
                    <Select
                        size="small"
                        variant="outlined"
                        value={deviceType}
                        onChange={handleDeviceTypeChange}
                    >
                        <MenuItem value='All'>All</MenuItem>
                        <MenuItem value='iot1'>IOT V1</MenuItem>
                        <MenuItem value='iot2'>IOT V2</MenuItem>
                        <MenuItem value='iot3'>IOT V3</MenuItem>
                    </Select>
                    <Button variant="contained" color="primary" onClick={getDevicesData}> <Search /></Button>                   
                </Box>
                <Box
                    component="span"
                    display="inline-block"
                    textAlign="right"
                    sx={{
                        '& > :not(style)': { m: 1 },
                        width: "20%"
                    }}>                               
                    <Button variant="contained" color="secondary" title="Upgrade device" onClick={performOTA}><Upload /></Button>
                    <Button variant="contained" color="primary" title="Upload CSV" onClick={uploadDevcies}><UploadFile /></Button>
                    <Button variant="contained" color="primary" title="Clear Selection" onClick={clearSelectedDevice}> <ClearAll /></Button>
                </Box>
            </Box>
            <Box sx={{width:"100%"}}>
                    { enableSelectAll && 
                     <FormGroup style={{float:"left",width:"20%",marginLeft:23}}>                                    
                        <FormControlLabel  control={<Checkbox checked={selectAll} onClick={selectAllDevices}/>} label="Select All" />                     
                    </FormGroup>  
                    }
                <TablePagination
                    sx={{float:"right",width:"50%"}}
                    component="div"
                    count={totalRow}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                />
            </Box>
            <DataGrid
                style={{width:"100%"}}
                getRowId={(row) => row.deviceIMEI}
                rows={devices}
                columns={columns}
                disableSelectionOnClick
                disableColumnMenu
                autoHeight={true}
                hideFooter={true}
            />
            <TablePagination
                sx={{float:"right",width:"50%"}}
                component="div"
                count={totalRow}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
            />
            <Popup
                title={'Set device for OTA : ' + putunderOTA.length + ' Devices' }
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <SelectionForm selectedDevices={putunderOTA} isErrorTrue={isErrorTrue} handleSubmit={handleOTASubmit} />
            </Popup>
            <Popup
                title={'Log for imei : ' + deviceIMEIForLog}
                openPopup={openLogPopup}
                setOpenPopup={setOpenLogPopup}                
            >
                <DeviceLog imei={deviceIMEIForLog}/>
            </Popup>
            <Popup
                title='Device Upload'
                openPopup={openDeviceUploadPopup}
                setOpenPopup={setOpenDeviceUploadPopup}
            >
                <DeviceUpload handleSubmit={handleDeviceUploadSubmit}/>
            </Popup>

            <Snackbar
                style={{ top: '30%' }}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={2000}
                open={alertObj.open}
                onClose={handleClose}
            >
                <Alert severity={alertObj.severity} sx={{ width: '100%' }}>
                    {alertObj.message}
                </Alert>
            </Snackbar>
            <OTAErrorModal
                open={showErrorModal}
                onClose={() => setShowErrorModal(false)}
                errors={otaErrors}
            />
        </div>
    )
}

export default DeviceTable